import api from '../../services/api';
import BaseService from '../BaseService';

class ProgramaFaqConfigService extends BaseService {
    constructor() {
        super('/programas/faq-config/');
    }

    getConfig(programaId) {
        return api.get(this.resource, { params: { programa_id: programaId } });
    }

    get(id, params) {
        if (id && typeof id !== 'object' && !params) {
            return this.getConfig(id);
        }
        return super.get(id, params);
    }
}

export default new ProgramaFaqConfigService();
